<template>
  <li class="goods-item">
    <div class="goods-info">
      <div class="goods-cover" @click="goDetail">
        <el-image
          fit="contain"
          :src="
            itemData.cover ||
            require('@/assets/images/default-bundle-cover.png') ||
            ''
          "
        ></el-image>
      </div>
      <div class="goods-name">
        <span @click="goDetail">{{ itemData.resourceName }}</span>
      </div>
    </div>

    <div class="goods-price ou-expand">
      <span class="price-span normal">{{
        (itemData.payMoney || 0) | paymentText
      }}</span>
    </div>
    <div v-show="type === 'preOrder'" class="goods-price-real">
      <span class="price-span">{{
        (itemData.payMoney || 0) | paymentText
      }}</span>
    </div>
  </li>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { apiDeleteCartItem, apiBatDeleteCartItems } from "@/api/cart/cart";
import { goodsInfoDetail } from "@/api/bookstore/bookstore";
import { specialDetailInfo } from "@/api/special/special";
export default {
  name: "CartItem",
  props: {
    type: { type: String, default: "preOrder" },
    itemIndex: { type: Number, default: -1 },
    itemData: { type: Object },
  },
  data() {
    return {
      visible: false,
    };
  },
  components: {},
  watch: {},
  filters: {
    paymentText(value) {
      let text = " - ";
      if (value || value === 0) {
        text = Number(value).toFixed(2);
      }
      return text;
    },
  },
  mounted() {},
  methods: {
    ...mapActions(["updateShoppingCart", "deleteShoppingCart", "checkAll"]),
    checkChange(val, key) {
      // 更新vuex中购物车商品是否勾选的状态
      console.log("勾选", val, key);
      this.updateShoppingCart({ key: key, prop: "isCheck", val: val });
    },
    deleteItem(e, id, goodsId) {
      this.$confirm(`确定要移除该商品吗？`, "系统提示", {
        type: "warning",
      }).then(() => {
        apiBatDeleteCartItems({ ids: id }).then((res) => {
          console.log("单条移除购物车商品返回", res);
          this.deleteShoppingCart(id);
          this.$message.success("移除成功");
        });
      });
    },
    goDetail() {
      let { sourceType } = this.itemData;
      if (sourceType === "subject") {
        specialDetailInfo(this.itemData.relevanceId).then((res) => {
          let status = res.data ? res.data.auditStatus : -1;
          if (status === "6") {
            this.$message.error("该专题已下架");
            return;
          }
          this.$router.push({
            path: "/special/specialDetail",
            query: { subjectId: this.itemData.relevanceId },
          });
        });
      } else {
        goodsInfoDetail(this.itemData.relevanceId)
          .then((res) => {
            if (res.data.goods) {
              let status =
                res.data && res.data.goods ? res.data.goods.status : -1;
              if (status === 6) {
                this.$message.error("该商品已下架");
                return;
              }
              if (this.itemData.goodsType != "train") {
                this.$router.push({
                  path: "/bookstore/bookstoreDetail",
                  query: {
                    goodsId: this.itemData.relevanceId,
                    goodsType: this.itemData.goodsType,
                  },
                });
              } else {
                this.$router.push({
                  path: "/willingLearn/bookstoreDetail",
                  query: { goodsId: this.itemData.relevanceId },
                });
              }
            } else {
              this.$router.push({
                path: "/user/myresourcesDetail",
                query: {
                  subjectId: res.data.ocResourceBundle.id,
                  resourceType: "bundle",
                  resource: "distribute",
                  relevanceId: res.data.ocResourceBundle.id,
                  type: "order",
                },
              });
            }
          })
          .catch((err) => {
            this.$message.error("获取商品详情失败, 暂时无法浏览");
          });
      }
    },
  },
};
</script>

